import { theme as baseTheme } from '@webnuts/university-greenland-shared-components'

export const theme = {
  ...baseTheme,
  breakpoints: {
    mobile: 480,
    tablet: 767,
    desktop: 1279,
    all: Infinity
  },
  rowGap: 20,
  color: {
    blueDark: '#2c4b6e',
    greyWhite: '#f9fbfd',
    greySilver: '#ebf4fa',
    greyLightest: '#ededed',
    greyLight: '#dddddd',
    grey: baseTheme.color.grey,
    greyDark: '#333333',
    greyDarker: '#222222',
    tomato: '#f24638',
    primary: baseTheme.color.primary,
    text: baseTheme.color.text
  },
  font: {
    play: "'Playfair Display', serif",
    lato: "'Lato', sans-serif"
  }
}
